import { Twitch, Youtube, Instagram, Twitter } from 'lucide-react';

const ICONS = { Twitch, Youtube, Twitter, Instagram };

const SOCIAL_LINKS = [
  { name: 'Twitch', url: 'https://www.twitch.tv/CiroGameShowTwitch', icon: 'Twitch', color: 'hover:bg-purple-600' },
  { name: 'YouTube', url: 'https://www.youtube.com/@CiroGameShow', icon: 'Youtube', color: 'hover:bg-red-600' },
  { name: 'Twitter', url: 'https://twitter.com/CiroGameShow', icon: 'Twitter', color: 'hover:bg-blue-500' },
  { name: 'Instagram', url: 'https://www.instagram.com/cirogameshow/', icon: 'Instagram', color: 'hover:bg-pink-600' }
];

export const SocialSection = () => (
  <section className="py-12 sm:py-20 px-4 bg-black/50">
    <div className="max-w-5xl mx-auto">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-center game-show-text mb-12">
        CONNECT WITH US
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
        {SOCIAL_LINKS.map((social) => {
          const Icon = ICONS[social.icon];
          return (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-card p-6 rounded-xl border-4 bg-gray-900 transition-all hover:scale-105 ${social.color}`}
            >
              <Icon className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3" />
              <p className="text-center font-black text-sm sm:text-base">{social.name.toUpperCase()}</p>
            </a>
          );
        })}
      </div>
    </div>
  </section>
);
